module.exports = __webpack_public_path__ + "img/blinifashion.abdbeda2.jpg";